import "core-js/modules/es.object.freeze.js";
export var STATUS_CODE = {
  ERROR: 'error',
  OK: 'ok'
};
Object.freeze(STATUS_CODE);